<div class="sections">
    <app-pilots-group [group]="form().controls.flight" [lookups]="lookups()"></app-pilots-group>
    @if (lookups().configs.crewEnabled) {
        <app-crew-members-group [rows]="form().controls.crews" [lookups]="lookups()" [members]="members()"></app-crew-members-group>
    }
    <app-passengers-group [group]="form().controls.flight" [lookups]="lookups()"></app-passengers-group>
</div>
